export default __webpack_public_path__ + "static/media/users.6dbf39d1.svg";